export default __webpack_public_path__ + "b304090ed546dacbb95eb4ecc09b0b4b.gif";